"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
const core_services_1 = require("@iotv/core-services");
const ModelCommon_1 = require("./ModelCommon");
const commonSupportedTypes = ['Gateway', 'Device', 'User', 'Customer'].sort((a, b) => a.localeCompare(b));
const supportedTypes = Object.fromEntries([...commonSupportedTypes]
    .filter((x) => x)
    .map((type) => [type, type])
    .sort());
const typeName = 'Group';
class Group extends ModelCommon_1.ModelCommon {
    constructor({ supportedType, subSupportedType, domain, ...ob }) {
        super(ob.type ?? typeName, ob);
        this.supportedType = supportedType;
        this.subSupportedType = subSupportedType;
        this.domain = domain;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            supportedType: {
                type: this.supportedType ? (commonSupportedTypes.includes(this.supportedType) ? 'Enum' : 'String') : 'Enum',
                editable: !this.supportedType,
                required: true,
                displayFn: () => (this.supportedType ? (0, core_services_1.toTitleCase)((0, core_services_1.camelCase_to_Sentence)(this.supportedType)) : undefined),
                enumKv: supportedTypes,
            },
        };
    }
}
exports.Group = Group;
